/**
 * Product Mobile Slider - Version Améliorée
 * Transforme les images produit en slider swipeable sur mobile
 * + Support miniatures + Support variantes
 */

(function() {
  'use strict';

  var MOBILE_BREAKPOINT = 768;
  var currentIndex = 0;
  var imageWrappers = [];
  var photosContainer = null;

  // Fonction principale qui s'exécute au chargement
  function initMobileSlider() {
    // Trouver le container d'images
    photosContainer = document.querySelector('.product-single__photos');

    if (!photosContainer) {
      console.log('Product Mobile Slider: Container non trouvé');
      return;
    }

    console.log('Product Mobile Slider: Container trouvé', photosContainer);

    // Trouver toutes les images
    imageWrappers = Array.from(photosContainer.querySelectorAll('.product-single__image-wrapper'));

    if (!imageWrappers || imageWrappers.length <= 1) {
      console.log('Product Mobile Slider: Pas assez d\'images (' + imageWrappers.length + ')');
      return;
    }

    console.log('Product Mobile Slider: ' + imageWrappers.length + ' images trouvées');

    // Fonction pour activer/désactiver selon la taille d'écran
    function handleResize() {
      var isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

      if (isMobile) {
        console.log('Product Mobile Slider: Mode mobile activé');
        enableMobileMode();
      } else {
        console.log('Product Mobile Slider: Mode desktop activé');
        disableMobileMode();
      }
    }

    // Activer le mode mobile
    function enableMobileMode() {
      // Retirer la classe hide de toutes les images
      imageWrappers.forEach(function(wrapper) {
        wrapper.classList.remove('hide');
      });

      // Créer les flèches si elles n'existent pas déjà
      if (!document.querySelector('.mobile-slider-arrow--left')) {
        createArrows();
      }

      // Afficher les flèches
      showArrows(true);
      
      // Activer les événements miniatures et variantes
      setupThumbnailListeners();
      setupVariantListener();
    }

    // Désactiver le mode mobile
    function disableMobileMode() {
      // Masquer les flèches
      showArrows(false);
    }

    // Créer les flèches de navigation
    function createArrows() {
      console.log('Product Mobile Slider: Création des flèches');

      // Flèche gauche
      var leftArrow = document.createElement('button');
      leftArrow.className = 'mobile-slider-arrow mobile-slider-arrow--left';
      leftArrow.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      leftArrow.setAttribute('aria-label', 'Image précédente');
      leftArrow.setAttribute('type', 'button');

      leftArrow.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Product Mobile Slider: Clic gauche');
        goToPrevious();
      });

      // Flèche droite
      var rightArrow = document.createElement('button');
      rightArrow.className = 'mobile-slider-arrow mobile-slider-arrow--right';
      rightArrow.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      rightArrow.setAttribute('aria-label', 'Image suivante');
      rightArrow.setAttribute('type', 'button');

      rightArrow.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Product Mobile Slider: Clic droit');
        goToNext();
      });

      // Ajouter les flèches au container
      photosContainer.appendChild(leftArrow);
      photosContainer.appendChild(rightArrow);

      console.log('Product Mobile Slider: Flèches créées');
    }

    // Afficher/masquer les flèches
    function showArrows(show) {
      var arrows = document.querySelectorAll('.mobile-slider-arrow');
      arrows.forEach(function(arrow) {
        arrow.style.display = show ? 'flex' : 'none';
      });
    }

    // Aller à l'image précédente
    function goToPrevious() {
      if (currentIndex > 0) {
        currentIndex--;
      } else {
        currentIndex = imageWrappers.length - 1;
      }
      scrollToImage(currentIndex);
    }

    // Aller à l'image suivante
    function goToNext() {
      if (currentIndex < imageWrappers.length - 1) {
        currentIndex++;
      } else {
        currentIndex = 0;
      }
      scrollToImage(currentIndex);
    }

    // =========================================
    // NOUVELLE FONCTION: Aller à une image par son ID
    // =========================================
    function goToImageById(imageId) {
      console.log('Product Mobile Slider: Recherche image ID:', imageId);
      
      var targetIndex = -1;
      
      // Trouver l'index de l'image avec cet ID
      imageWrappers.forEach(function(wrapper, index) {
        var wrapperId = wrapper.getAttribute('data-image-id');
        if (wrapperId === imageId || wrapperId === imageId.toString()) {
          targetIndex = index;
        }
      });
      
      if (targetIndex !== -1) {
        console.log('Product Mobile Slider: Image trouvée à l\'index', targetIndex);
        currentIndex = targetIndex;
        scrollToImage(targetIndex);
        updateThumbnails(imageId);
        return true;
      }
      
      console.warn('Product Mobile Slider: Image non trouvée pour ID:', imageId);
      return false;
    }

    // Scroller vers une image
    function scrollToImage(index) {
      console.log('Product Mobile Slider: Scroll vers image ' + index);

      if (imageWrappers[index]) {
        imageWrappers[index].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
        
        // Mettre à jour les miniatures
        var imageId = imageWrappers[index].getAttribute('data-image-id');
        if (imageId) {
          updateThumbnails(imageId);
        }
      }
    }

    // =========================================
    // NOUVELLE FONCTION: Mettre à jour les miniatures
    // =========================================
    function updateThumbnails(activeImageId) {
      var thumbnails = document.querySelectorAll('.product-single__thumbnail');
      
      thumbnails.forEach(function(thumb) {
        thumb.classList.remove('is-active');
        
        var thumbImageId = thumb.getAttribute('data-image-id');
        if (thumbImageId === activeImageId || thumbImageId === activeImageId.toString()) {
          thumb.classList.add('is-active');
          
          // Scroll vers la miniature active sur mobile
          if (window.innerWidth <= MOBILE_BREAKPOINT) {
            setTimeout(function() {
              thumb.parentElement.scrollIntoView({
                behavior: 'smooth',
                inline: 'center',
                block: 'nearest'
              });
            }, 100);
          }
        }
      });
    }

    // =========================================
    // NOUVELLE FONCTION: Écouter les clics sur miniatures
    // =========================================
    function setupThumbnailListeners() {
      var thumbnails = document.querySelectorAll('.product-single__thumbnail');
      
      console.log('Product Mobile Slider: Setup de ' + thumbnails.length + ' miniatures');
      
      thumbnails.forEach(function(thumb) {
        // Retirer les anciens listeners (éviter les doublons)
        var newThumb = thumb.cloneNode(true);
        thumb.parentNode.replaceChild(newThumb, thumb);
        
        // Ajouter le nouveau listener
        newThumb.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          var imageId = this.getAttribute('data-image-id');
          console.log('Product Mobile Slider: Clic miniature - Image ID:', imageId);
          
          if (window.innerWidth <= MOBILE_BREAKPOINT) {
            goToImageById(imageId);
          }
        });
      });
    }

    // =========================================
    // NOUVELLE FONCTION: Écouter les changements de variantes
    // =========================================
    function setupVariantListener() {
      var variantSelectors = document.querySelectorAll('select[name="id"], #ProductSelect');
      
      console.log('Product Mobile Slider: Setup de ' + variantSelectors.length + ' sélecteurs de variantes');
      
      variantSelectors.forEach(function(selector) {
        selector.addEventListener('change', function() {
          var selectedVariantId = this.value;
          console.log('Product Mobile Slider: Changement variante:', selectedVariantId);
          
          // Récupérer l'image de la variante depuis le JSON
          var productJsonEl = document.querySelector('script[type="application/json"][id*="ProductJson"]');
          
          if (productJsonEl && window.innerWidth <= MOBILE_BREAKPOINT) {
            try {
              var product = JSON.parse(productJsonEl.textContent);
              var variant = product.variants.find(function(v) {
                return v.id == selectedVariantId;
              });
              
              if (variant && variant.featured_image && variant.featured_image.id) {
                var imageId = variant.featured_image.id.toString();
                console.log('Product Mobile Slider: Image variante trouvée:', imageId);
                
                setTimeout(function() {
                  goToImageById(imageId);
                }, 100);
              }
            } catch (error) {
              console.error('Product Mobile Slider: Erreur JSON:', error);
            }
          }
        });
      });
    }

    // Détecter l'image visible après un swipe manuel
    function updateCurrentIndex() {
      var containerRect = photosContainer.getBoundingClientRect();
      var containerCenter = containerRect.left + containerRect.width / 2;

      imageWrappers.forEach(function(wrapper, index) {
        var rect = wrapper.getBoundingClientRect();
        var imageCenter = rect.left + rect.width / 2;

        if (Math.abs(imageCenter - containerCenter) < rect.width / 2) {
          currentIndex = index;
          
          // Mettre à jour les miniatures après un swipe manuel
          var imageId = wrapper.getAttribute('data-image-id');
          if (imageId) {
            updateThumbnails(imageId);
          }
        }
      });
    }

    // Event listeners
    photosContainer.addEventListener('scroll', function() {
      clearTimeout(photosContainer.scrollTimeout);
      photosContainer.scrollTimeout = setTimeout(updateCurrentIndex, 150);
    });

    window.addEventListener('resize', handleResize);

    // Initialiser
    handleResize();
    
    // Marquer la première image comme active
    setTimeout(function() {
      if (imageWrappers[0]) {
        var firstImageId = imageWrappers[0].getAttribute('data-image-id');
        updateThumbnails(firstImageId);
      }
    }, 500);
  }

  // Attendre que le DOM soit complètement chargé
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileSlider);
  } else {
    // Le DOM est déjà chargé
    initMobileSlider();
  }

  // Réinitialiser si Shopify recharge dynamiquement la section
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId.includes('product')) {
      setTimeout(initMobileSlider, 300);
    }
  });

})();